/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_ProductionItemDto } from '../models/PagedResultDto_ProductionItemDto';
import type { Wealthlane_Dtos_Production_ProductionResponseDto } from '../models/Wealthlane_Dtos_Production_ProductionResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ProductionService {

    /**
     * @param formData 
     * @returns Wealthlane_Dtos_Production_ProductionResponseDto OK
     * @throws ApiError
     */
    public static postApiIdentityApiProduction(
formData?: {
SandboxTenantId?: string;
Remarks?: string;
},
): CancelablePromise<Wealthlane_Dtos_Production_ProductionResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/identity/api/production',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param filter 
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns PagedResultDto_ProductionItemDto OK
     * @throws ApiError
     */
    public static getApiIdentityApiProduction(
filter?: string,
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<PagedResultDto_ProductionItemDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/identity/api/production',
            query: {
                'Filter': filter,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
